module.exports = "pegasus/assets/blocks/column-9-theme6.png";